module.exports = __webpack_public_path__ + "img/tabela_de_preco.2da8abe4.png";